import { ok } from "devlop";
import { parseEntities } from "parse-entities";
import { stringifyEntitiesLight } from "stringify-entities";
import { visitParents } from "unist-util-visit-parents";
import { codes, types, constants } from "micromark-util-symbol";
import { factorySpace } from "micromark-factory-space";
import { asciiAlpha, markdownSpace, markdownLineEndingOrSpace, asciiAlphanumeric, markdownLineEnding } from "micromark-util-character";
import { factoryWhitespace } from "micromark-factory-whitespace";
const own = {}.hasOwnProperty;
const shortcut = /^[^\t\n\r "#'.<=>`}]+$/;
handleDirective.peek = peekDirective;
function directiveFromMarkdown() {
  return {
    enter: {
      directiveContainer: enterContainer,
      directiveContainerAttributes: enterAttributes,
      directiveContainerLabel: enterContainerLabel
    },
    exit: {
      directiveContainer: exit,
      directiveContainerAttributeClassValue: exitAttributeClassValue,
      directiveContainerAttributeIdValue: exitAttributeIdValue,
      directiveContainerAttributeName: exitAttributeName,
      directiveContainerAttributeValue: exitAttributeValue,
      directiveContainerAttributes: exitAttributes,
      directiveContainerLabel: exitContainerLabel,
      directiveContainerName: exitName
    }
  };
}
function directiveToMarkdown() {
  return {
    unsafe: [
      {
        character: "\r",
        inConstruct: ["containerDirectiveLabel"]
      },
      {
        character: "\n",
        inConstruct: ["containerDirectiveLabel"]
      },
      {
        before: "[^:]",
        character: ":",
        after: "[A-Za-z]",
        inConstruct: ["phrasing"]
      },
      { atBreak: true, character: ":", after: ":" }
    ],
    handlers: {
      containerDirective: handleDirective
    }
  };
}
function enterContainer(token) {
  enter.call(this, "containerDirective", token);
}
function enter(type, token) {
  this.enter({ type, name: "", attributes: {}, children: [] }, token);
}
function exitName(token) {
  const node = this.stack[this.stack.length - 1];
  ok(
    node.type === "containerDirective" || node.type === "leafDirective" || node.type === "textDirective"
  );
  node.name = this.sliceSerialize(token);
}
function enterContainerLabel(token) {
  this.enter(
    { type: "paragraph", data: { directiveLabel: true }, children: [] },
    token
  );
}
function exitContainerLabel(token) {
  this.exit(token);
}
function enterAttributes() {
  this.data.directiveAttributes = [];
  this.buffer();
}
function exitAttributeIdValue(token) {
  const list = this.data.directiveAttributes;
  ok(list, "expected `directiveAttributes`");
  list.push([
    "id",
    parseEntities(this.sliceSerialize(token), {
      attribute: true
    })
  ]);
}
function exitAttributeClassValue(token) {
  const list = this.data.directiveAttributes;
  ok(list, "expected `directiveAttributes`");
  list.push([
    "class",
    parseEntities(this.sliceSerialize(token), {
      attribute: true
    })
  ]);
}
function exitAttributeValue(token) {
  const list = this.data.directiveAttributes;
  ok(list, "expected `directiveAttributes`");
  list[list.length - 1][1] = parseEntities(this.sliceSerialize(token), {
    attribute: true
  });
}
function exitAttributeName(token) {
  const list = this.data.directiveAttributes;
  ok(list, "expected `directiveAttributes`");
  list.push([this.sliceSerialize(token), ""]);
}
function exitAttributes() {
  const list = this.data.directiveAttributes;
  ok(list, "expected `directiveAttributes`");
  const cleaned = {};
  let index = -1;
  while (++index < list.length) {
    const attribute = list[index];
    if (attribute[0] === "class" && cleaned.class) {
      cleaned.class += " " + attribute[1];
    } else {
      cleaned[attribute[0]] = attribute[1];
    }
  }
  this.data.directiveAttributes = void 0;
  this.resume();
  const node = this.stack[this.stack.length - 1];
  ok(
    node.type === "containerDirective" || node.type === "leafDirective" || node.type === "textDirective"
  );
  node.attributes = cleaned;
}
function exit(token) {
  this.exit(token);
}
function handleDirective(node, _, state, info) {
  const tracker = state.createTracker(info);
  const sequence = fence(node);
  const exit2 = state.enter(node.type);
  let value = tracker.move(sequence + (node.name || ""));
  let label2;
  if (node.type === "containerDirective") {
    const head = (node.children || [])[0];
    label2 = inlineDirectiveLabel(head) ? head : void 0;
  } else {
    label2 = node;
  }
  if (label2 && label2.children && label2.children.length > 0) {
    const exit3 = state.enter("label");
    const labelType = `${node.type}Label`;
    const subexit = state.enter(labelType);
    value += tracker.move("[");
    value += tracker.move(
      state.containerPhrasing(label2, {
        ...tracker.current(),
        before: value,
        after: "]"
      })
    );
    value += tracker.move("]");
    subexit();
    exit3();
  }
  value += tracker.move(attributes$1(node, state));
  if (node.type === "containerDirective") {
    const head = (node.children || [])[0];
    let shallow = node;
    if (inlineDirectiveLabel(head)) {
      shallow = Object.assign({}, node, { children: node.children.slice(1) });
    }
    if (shallow && shallow.children && shallow.children.length > 0) {
      value += tracker.move("\n");
      value += tracker.move(state.containerFlow(shallow, tracker.current()));
    }
    value += tracker.move("\n" + sequence);
  }
  exit2();
  return value;
}
function peekDirective() {
  return ":";
}
function attributes$1(node, state) {
  const quote = state.options.quote || '"';
  const subset = node.type === "textDirective" ? [quote] : [quote, "\n", "\r"];
  const attrs = node.attributes || {};
  const values = [];
  let classesFull;
  let classes;
  let id;
  let key;
  for (key in attrs) {
    if (own.call(attrs, key) && attrs[key] !== void 0 && attrs[key] !== null) {
      const value = String(attrs[key]);
      if (key === "id") {
        id = shortcut.test(value) ? "#" + value : quoted("id", value);
      } else if (key === "class") {
        const list = value.split(/[\t\n\r ]+/g);
        const classesFullList = [];
        const classesList = [];
        let index = -1;
        while (++index < list.length) {
          (shortcut.test(list[index]) ? classesList : classesFullList).push(
            list[index]
          );
        }
        classesFull = classesFullList.length > 0 ? quoted("class", classesFullList.join(" ")) : "";
        classes = classesList.length > 0 ? "." + classesList.join(".") : "";
      } else {
        values.push(quoted(key, value));
      }
    }
  }
  if (classesFull) {
    values.unshift(classesFull);
  }
  if (classes) {
    values.unshift(classes);
  }
  if (id) {
    values.unshift(id);
  }
  return values.length > 0 ? "{" + values.join(" ") + "}" : "";
  function quoted(key2, value) {
    return key2 + (value ? "=" + quote + stringifyEntitiesLight(value, { subset }) + quote : "");
  }
}
function inlineDirectiveLabel(node) {
  return Boolean(
    node && node.type === "paragraph" && node.data && node.data.directiveLabel
  );
}
function fence(node) {
  let size = 0;
  if (node.type === "containerDirective") {
    visitParents(node, function(node2, parents) {
      if (node2.type === "containerDirective") {
        let index = parents.length;
        let nesting = 0;
        while (index--) {
          if (parents[index].type === "containerDirective") {
            nesting++;
          }
        }
        if (nesting > size)
          size = nesting;
      }
    });
    size += 3;
  } else if (node.type === "leafDirective") {
    size = 2;
  } else {
    size = 1;
  }
  return ":".repeat(size);
}
function factoryAttributes(effects, ok$1, nok, attributesType, attributesMarkerType, attributeType, attributeIdType, attributeClassType, attributeNameType, attributeInitializerType, attributeValueLiteralType, attributeValueType, attributeValueMarker, attributeValueData, disallowEol) {
  let type;
  let marker;
  return start;
  function start(code) {
    ok(code === codes.leftCurlyBrace, "expected `{`");
    effects.enter(attributesType);
    effects.enter(attributesMarkerType);
    effects.consume(code);
    effects.exit(attributesMarkerType);
    return between;
  }
  function between(code) {
    if (code === codes.numberSign) {
      type = attributeIdType;
      return shortcutStart(code);
    }
    if (code === codes.dot) {
      type = attributeClassType;
      return shortcutStart(code);
    }
    if (code === codes.colon || code === codes.underscore || asciiAlpha(code)) {
      effects.enter(attributeType);
      effects.enter(attributeNameType);
      effects.consume(code);
      return name;
    }
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, between, types.whitespace)(code);
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, between)(code);
    }
    return end(code);
  }
  function shortcutStart(code) {
    const markerType = type + "Marker";
    effects.enter(attributeType);
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    return shortcutStartAfter;
  }
  function shortcutStartAfter(code) {
    if (code === codes.eof || code === codes.quotationMark || code === codes.numberSign || code === codes.apostrophe || code === codes.dot || code === codes.lessThan || code === codes.equalsTo || code === codes.greaterThan || code === codes.graveAccent || code === codes.rightCurlyBrace || markdownLineEndingOrSpace(code)) {
      return nok(code);
    }
    const valueType = type + "Value";
    effects.enter(valueType);
    effects.consume(code);
    return shortcut2;
  }
  function shortcut2(code) {
    if (code === codes.eof || code === codes.quotationMark || code === codes.apostrophe || code === codes.lessThan || code === codes.equalsTo || code === codes.greaterThan || code === codes.graveAccent) {
      return nok(code);
    }
    if (code === codes.numberSign || code === codes.dot || code === codes.rightCurlyBrace || markdownLineEndingOrSpace(code)) {
      const valueType = type + "Value";
      effects.exit(valueType);
      effects.exit(type);
      effects.exit(attributeType);
      return between(code);
    }
    effects.consume(code);
    return shortcut2;
  }
  function name(code) {
    if (code === codes.dash || code === codes.dot || code === codes.colon || code === codes.underscore || asciiAlphanumeric(code)) {
      effects.consume(code);
      return name;
    }
    effects.exit(attributeNameType);
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, nameAfter, types.whitespace)(code);
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, nameAfter)(code);
    }
    return nameAfter(code);
  }
  function nameAfter(code) {
    if (code === codes.equalsTo) {
      effects.enter(attributeInitializerType);
      effects.consume(code);
      effects.exit(attributeInitializerType);
      return valueBefore;
    }
    effects.exit(attributeType);
    return between(code);
  }
  function valueBefore(code) {
    if (code === codes.eof || code === codes.lessThan || code === codes.equalsTo || code === codes.greaterThan || code === codes.graveAccent || code === codes.rightCurlyBrace || disallowEol && markdownLineEnding(code)) {
      return nok(code);
    }
    if (code === codes.quotationMark || code === codes.apostrophe) {
      effects.enter(attributeValueLiteralType);
      effects.enter(attributeValueMarker);
      effects.consume(code);
      effects.exit(attributeValueMarker);
      marker = code;
      return valueQuotedStart;
    }
    if (disallowEol && markdownSpace(code)) {
      return factorySpace(effects, valueBefore, types.whitespace)(code);
    }
    if (!disallowEol && markdownLineEndingOrSpace(code)) {
      return factoryWhitespace(effects, valueBefore)(code);
    }
    effects.enter(attributeValueType);
    effects.enter(attributeValueData);
    effects.consume(code);
    marker = void 0;
    return valueUnquoted;
  }
  function valueUnquoted(code) {
    if (code === codes.eof || code === codes.quotationMark || code === codes.apostrophe || code === codes.lessThan || code === codes.equalsTo || code === codes.greaterThan || code === codes.graveAccent) {
      return nok(code);
    }
    if (code === codes.rightCurlyBrace || markdownLineEndingOrSpace(code)) {
      effects.exit(attributeValueData);
      effects.exit(attributeValueType);
      effects.exit(attributeType);
      return between(code);
    }
    effects.consume(code);
    return valueUnquoted;
  }
  function valueQuotedStart(code) {
    if (code === marker) {
      effects.enter(attributeValueMarker);
      effects.consume(code);
      effects.exit(attributeValueMarker);
      effects.exit(attributeValueLiteralType);
      effects.exit(attributeType);
      return valueQuotedAfter;
    }
    effects.enter(attributeValueType);
    return valueQuotedBetween(code);
  }
  function valueQuotedBetween(code) {
    if (code === marker) {
      effects.exit(attributeValueType);
      return valueQuotedStart(code);
    }
    if (code === codes.eof) {
      return nok(code);
    }
    if (markdownLineEnding(code)) {
      return disallowEol ? nok(code) : factoryWhitespace(effects, valueQuotedBetween)(code);
    }
    effects.enter(attributeValueData);
    effects.consume(code);
    return valueQuoted;
  }
  function valueQuoted(code) {
    if (code === marker || code === codes.eof || markdownLineEnding(code)) {
      effects.exit(attributeValueData);
      return valueQuotedBetween(code);
    }
    effects.consume(code);
    return valueQuoted;
  }
  function valueQuotedAfter(code) {
    return code === codes.rightCurlyBrace || markdownLineEndingOrSpace(code) ? between(code) : end(code);
  }
  function end(code) {
    if (code === codes.rightCurlyBrace) {
      effects.enter(attributesMarkerType);
      effects.consume(code);
      effects.exit(attributesMarkerType);
      effects.exit(attributesType);
      return ok$1;
    }
    return nok(code);
  }
}
function factoryLabel(effects, ok$1, nok, type, markerType, stringType, disallowEol) {
  let size = 0;
  let balance = 0;
  let previous;
  return start;
  function start(code) {
    ok(code === codes.leftSquareBracket, "expected `[`");
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    return afterStart;
  }
  function afterStart(code) {
    if (code === codes.rightSquareBracket) {
      effects.enter(markerType);
      effects.consume(code);
      effects.exit(markerType);
      effects.exit(type);
      return ok$1;
    }
    effects.enter(stringType);
    return lineStart(code);
  }
  function lineStart(code) {
    if (code === codes.rightSquareBracket && !balance) {
      return atClosingBrace(code);
    }
    const token = effects.enter(types.chunkText, {
      contentType: constants.contentTypeText,
      previous
    });
    if (previous)
      previous.next = token;
    previous = token;
    return data(code);
  }
  function data(code) {
    if (code === codes.eof || size > constants.linkReferenceSizeMax) {
      return nok(code);
    }
    if (code === codes.leftSquareBracket && ++balance > constants.linkResourceDestinationBalanceMax) {
      return nok(code);
    }
    if (code === codes.rightSquareBracket && !balance--) {
      effects.exit(types.chunkText);
      return atClosingBrace(code);
    }
    if (markdownLineEnding(code)) {
      if (disallowEol) {
        return nok(code);
      }
      effects.consume(code);
      effects.exit(types.chunkText);
      return lineStart;
    }
    effects.consume(code);
    return code === codes.backslash ? dataEscape : data;
  }
  function dataEscape(code) {
    if (code === codes.leftSquareBracket || code === codes.backslash || code === codes.rightSquareBracket) {
      effects.consume(code);
      size++;
      return data;
    }
    return data(code);
  }
  function atClosingBrace(code) {
    effects.exit(stringType);
    effects.enter(markerType);
    effects.consume(code);
    effects.exit(markerType);
    effects.exit(type);
    return ok$1;
  }
}
function checkEmojiCode(code) {
  return code > 200 && code < 6e4;
}
const expendCodeList = [32];
function expendCode(code) {
  return code !== null && (expendCodeList.includes(code) || checkEmojiCode(code));
}
function factoryName(effects, ok2, nok, type) {
  const self = this;
  return start;
  function start(code) {
    if (expendCode(code) || asciiAlpha(code)) {
      effects.enter(type);
      effects.consume(code);
      return name;
    }
    return nok(code);
  }
  function name(code) {
    if (code === codes.dash || code === codes.underscore || asciiAlphanumeric(code) || expendCode(code)) {
      effects.consume(code);
      return name;
    }
    effects.exit(type);
    return self.previous === codes.dash || self.previous === codes.underscore ? nok(code) : ok2(code);
  }
}
const directiveContainer = {
  tokenize: tokenizeDirectiveContainer,
  concrete: true
};
const label = { tokenize: tokenizeLabel, partial: true };
const attributes = { tokenize: tokenizeAttributes, partial: true };
const nonLazyLine = { tokenize: tokenizeNonLazyLine, partial: true };
function tokenizeDirectiveContainer(effects, ok$1, nok) {
  const self = this;
  const tail = self.events[self.events.length - 1];
  const initialSize = tail && tail[1].type === types.linePrefix ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let sizeOpen = 0;
  let previous;
  return start;
  function start(code) {
    ok(code === codes.colon, "expected `:`");
    effects.enter("directiveContainer");
    effects.enter("directiveContainerFence");
    effects.enter("directiveContainerSequence");
    return sequenceOpen(code);
  }
  function sequenceOpen(code) {
    if (code === codes.colon) {
      effects.consume(code);
      sizeOpen++;
      return sequenceOpen;
    }
    if (sizeOpen < constants.codeFencedSequenceSizeMin) {
      return nok(code);
    }
    effects.exit("directiveContainerSequence");
    return factoryName.call(
      self,
      effects,
      afterName,
      nok,
      "directiveContainerName"
    )(code);
  }
  function afterName(code) {
    return code === codes.leftSquareBracket ? effects.attempt(label, afterLabel, afterLabel)(code) : afterLabel(code);
  }
  function afterLabel(code) {
    return code === codes.leftCurlyBrace ? effects.attempt(attributes, afterAttributes, afterAttributes)(code) : afterAttributes(code);
  }
  function afterAttributes(code) {
    return factorySpace(effects, openAfter, types.whitespace)(code);
  }
  function openAfter(code) {
    effects.exit("directiveContainerFence");
    if (code === codes.eof) {
      return afterOpening(code);
    }
    if (markdownLineEnding(code)) {
      if (self.interrupt) {
        return ok$1(code);
      }
      return effects.attempt(nonLazyLine, contentStart, afterOpening)(code);
    }
    return nok(code);
  }
  function afterOpening(code) {
    effects.exit("directiveContainer");
    return ok$1(code);
  }
  function contentStart(code) {
    if (code === codes.eof) {
      effects.exit("directiveContainer");
      return ok$1(code);
    }
    effects.enter("directiveContainerContent");
    return lineStart(code);
  }
  function lineStart(code) {
    if (code === codes.eof) {
      return after(code);
    }
    return effects.attempt(
      { tokenize: tokenizeClosingFence, partial: true },
      after,
      initialSize ? factorySpace(effects, chunkStart, types.linePrefix, initialSize + 1) : chunkStart
    )(code);
  }
  function chunkStart(code) {
    if (code === codes.eof) {
      return after(code);
    }
    const token = effects.enter(types.chunkDocument, {
      contentType: constants.contentTypeDocument,
      previous
    });
    if (previous)
      previous.next = token;
    previous = token;
    return contentContinue(code);
  }
  function contentContinue(code) {
    if (code === codes.eof) {
      const t = effects.exit(types.chunkDocument);
      self.parser.lazy[t.start.line] = false;
      return after(code);
    }
    if (markdownLineEnding(code)) {
      return effects.check(nonLazyLine, nonLazyLineAfter, lineAfter)(code);
    }
    effects.consume(code);
    return contentContinue;
  }
  function nonLazyLineAfter(code) {
    effects.consume(code);
    const t = effects.exit(types.chunkDocument);
    self.parser.lazy[t.start.line] = false;
    return lineStart;
  }
  function lineAfter(code) {
    const t = effects.exit(types.chunkDocument);
    self.parser.lazy[t.start.line] = false;
    return after(code);
  }
  function after(code) {
    effects.exit("directiveContainerContent");
    effects.exit("directiveContainer");
    return ok$1(code);
  }
  function tokenizeClosingFence(effects2, ok2, nok2) {
    let size = 0;
    return factorySpace(
      effects2,
      closingPrefixAfter,
      types.linePrefix,
      constants.tabSize
    );
    function closingPrefixAfter(code) {
      effects2.enter("directiveContainerFence");
      effects2.enter("directiveContainerSequence");
      return closingSequence(code);
    }
    function closingSequence(code) {
      if (code === codes.colon) {
        effects2.consume(code);
        size++;
        return closingSequence;
      }
      if (size < sizeOpen)
        return nok2(code);
      effects2.exit("directiveContainerSequence");
      return factorySpace(effects2, closingSequenceEnd, types.whitespace)(code);
    }
    function closingSequenceEnd(code) {
      if (code === codes.eof || markdownLineEnding(code)) {
        effects2.exit("directiveContainerFence");
        return ok2(code);
      }
      return nok2(code);
    }
  }
}
function tokenizeLabel(effects, ok2, nok) {
  return factoryLabel(
    effects,
    ok2,
    nok,
    "directiveContainerLabel",
    "directiveContainerLabelMarker",
    "directiveContainerLabelString",
    true
  );
}
function tokenizeAttributes(effects, ok2, nok) {
  return factoryAttributes(
    effects,
    ok2,
    nok,
    "directiveContainerAttributes",
    "directiveContainerAttributesMarker",
    "directiveContainerAttribute",
    "directiveContainerAttributeId",
    "directiveContainerAttributeClass",
    "directiveContainerAttributeName",
    "directiveContainerAttributeInitializerMarker",
    "directiveContainerAttributeValueLiteral",
    "directiveContainerAttributeValue",
    "directiveContainerAttributeValueMarker",
    "directiveContainerAttributeValueData",
    true
  );
}
function tokenizeNonLazyLine(effects, ok$1, nok) {
  const self = this;
  return start;
  function start(code) {
    ok(markdownLineEnding(code), "expected eol");
    effects.enter(types.lineEnding);
    effects.consume(code);
    effects.exit(types.lineEnding);
    return lineStart;
  }
  function lineStart(code) {
    return self.parser.lazy[self.now().line] ? nok(code) : ok$1(code);
  }
}
function directive() {
  return {
    flow: { [codes.colon]: [directiveContainer] }
  };
}
function remarkDirective() {
  const self = this;
  const data = self.data();
  const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
  const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
  const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
  micromarkExtensions.push(directive());
  fromMarkdownExtensions.push(directiveFromMarkdown());
  toMarkdownExtensions.push(directiveToMarkdown());
}
function breaks(plugins) {
  const remark = (processor) => {
    let nextProcessors = processor.use(remarkDirective);
    plugins.forEach((plugin) => {
      if (plugin.remark) {
        nextProcessors = plugin.remark(nextProcessors);
      }
    });
    return nextProcessors;
  };
  const mdxRemark = (processor) => processor.use(remarkDirective);
  plugins.map((plugin) => plugin.mdxHandlerList);
  return {
    remark,
    mdxRemark,
    mdxHandlerList: (options) => {
      const handlerList = plugins.filter((plugin) => plugin.mdxHandlerList).map((plugin) => plugin.mdxHandlerList(options));
      return (rawInput, prev) => {
        const input = handlerList.reduce(
          (res, handler) => handler(res, prev),
          rawInput
        );
        if ("res" in input)
          return input;
        const node = input.source;
        if (node.type === "textDirective") {
          return {
            res: null
          };
        }
        if (node.type === "containerDirective") {
          return {
            res: null
          };
        }
        if (node.type === "leafDirective") {
          return {
            res: null
          };
        }
        return input;
      };
    }
  };
}
export {
  breaks as default
};
